module.exports = __webpack_public_path__ + "static/media/Paus soffa 2-sits med recliners pausakomb375hg detalj 2023 11.448afd6c.jpg";